let routes = [
	{
		// 问卷
		path: '/Health',
		name: 'Health',
		component: () => import('@/views/Questionnaire/Health/Health'),
		meta: {
			title: '健康问卷',
			keepAlive: true
		}
	},
    {
        path:'/Answer',
        name:'Answers',
        component:() => import('@/views/Questionnaire/Answer/Answer'),
        meta:{
            title: '答题中...',
        },
      },
  {
    path:'/routineResults',
    name:'routineResults',
    component:() => import('@/views/Questionnaire/routineResults/routineResults'),
    meta:{
        title: '常规问卷',
    },
  },
  {
    path:'/psychology',
    name:'psychologys',
    component:() => import('@/views/Questionnaire/psychology/psychology'),
    meta:{
        title: '心理问卷',
    },
  },
  {
    path:'/customizeResults',
    name:'customizeResults',
    component:() => import('@/views/Questionnaire/customizeResults/customizeResults'),
    meta:{
      title: '自定义问卷',
    },
  },
  {
    path:'/customize',
    name:'customize',
    component:() => import('@/views/Questionnaire/Answer/customize'),
    meta:{
        title: '答题中...',
    },
  },
  {
    path:'/chineseMedicine',
    name:'chineseMedicines',
    component:() => import('@/views/Questionnaire/chineseMedicine/chineseMedicine'),
    meta:{
        title: '中医问卷',
    },
  },
  {
    path:'/result',
    name:'results',
    component:() => import('@/views/Questionnaire/result/result'),
    meta:{
        title: '查看测试结果',
    },
  },
  {
      path:'/basics',
      name:'basics',
      component:() => import('@/views/Questionnaire/basics/Answer'),
      meta:{
          title: '基础信息',
      },
    },
    {
      path:'/addbs',
      name:'addbs',
      component:() => import('@/views/login/writeQuestionnaire'),
      meta:{
          title: '填写问卷',
      },
    },
    {
      path:'/FoundationInfo',
      name:'FoundationInfo',
      component:() => import('@/views/login/FoundationInfo'),
      meta:{
          title: '基础问卷',
      },
    },
    {
      path:'/basicsresult',
      name:'basicsresult',
      component:() => import('@/views/Questionnaire/basics/index'),
      meta:{
          title: '问卷结果',
      },
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/Questionnaire.js